import { Box, ButtonBase, Typography } from "@mui/material";

const PaymentHistoryCard = ({
  paymentId,
  paymentDescription,
  paymentDate,
  paymentStatus,
  paymentAmount,
  onClick,
  selected,
  noPointer,
}) => {
  return (
    <ButtonBase
      style={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#1F222A",
        borderRadius: "10px",
        padding: "10px 20px",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: !selected && !noPointer ? "pointer" : "default",
        gap: "10px",
        transition: "border 0.3s, box-shadow 0.3s",
        border: selected ? "2px solid #FF6401" : "2px solid rgba(255, 255, 255, 0)",
      }}
      onClick={onClick}
    >
      <Box>
        <Typography
          style={{
            fontSize: paymentStatus != "REJECTED" ? "24px" : "20px",
            fontFamily: "Urbanist",
            fontWeight: "bold",
            color: paymentStatus != "REJECTED" ? "rgba(255, 255, 255, 1)" : "#FF1F01",
            textAlign: "left",
          }}
        >
          {`Pago N° ${paymentId}`}
          {paymentStatus === "REJECTED" ? " - Rechazado" : paymentStatus === "NOT_PROCESSED" ? " - Pendiente" : ""}
        </Typography>
        <Typography
          style={{
            fontSize: "15px",
            fontFamily: "Urbanist",
            fontWeight: "500",
            color: "rgba(255, 255, 255, 1)",
            maxWidth: "300px",
            textAlign: "left",
          }}
        >
          {paymentDescription}
        </Typography>
      </Box>
      <Box>
        <Typography
          style={{
            fontSize: "20px",
            fontFamily: "Urbanist",
            fontWeight: "400",
            color: "rgba(255, 255, 255, 1)",
            textAlign: "center",
          }}
        >
          {paymentDate}
        </Typography>
        <Typography
          style={{
            fontSize: "22px",
            fontFamily: "Urbanist",
            fontWeight: "500",
            color: "rgba(255, 255, 255, 1)",
            textAlign: "center",
          }}
        >
          {paymentAmount}
        </Typography>
      </Box>
    </ButtonBase>
  );
};

export default PaymentHistoryCard;
